import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { UserModel } from '../../modules/user/model/user.model';
import { IndexLoggingService } from '../services/index-logging.service';

//const localenv = require('../../../../server-console/shared/localEnv.js');
const LocalEnv = require('../../../../server-console/shared/localEnv.js');

const logIndex = LocalEnv.CONSOLE_LOG_INDEX;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private indexLoggingService: IndexLoggingService
  ) {}

  handleError(error: Error): void {
    let userInfo: UserModel = JSON.parse(localStorage.getItem('userInfo'));

    let userEmail: string = userInfo.hasOwnProperty('email')
      ? userInfo.email
      : 'User email not found in local strorage';

    let router: Router = this.injector.get(Router);

    if (!(error instanceof HttpErrorResponse)) {
      const apiDocument = {
        error: {
          message: error.message,
          stackTrace: error.stack,
          type: 'adminportal-web-client',
          code: error.name
        },
        url: {
          full: router.url,
          original: router.url
        },
        user: {
          email: userEmail
        }
      };
      this.indexLoggingService
        .postLogginIndex(logIndex, apiDocument)
        .subscribe((res: any) => {
          console.log('successfully logging into index.', res);
        });
    }
  }
}
